// Remembers what a user last built so reopening a builder starts from their
// own details rather than an empty form. Client-side only: the generated
// documents live on the backend's container disk and do not survive a deploy.

const KEY_PREFIX = 'application-builder-form-v1';

function userScopedKey(documentType) {
  const base = `${KEY_PREFIX}-${documentType}`;
  try {
    const userStr = localStorage.getItem('user') || localStorage.getItem('auth_user');
    if (userStr) {
      const user = JSON.parse(userStr);
      if (user.email || user.id) return `${base}-${user.email || user.id}`;
    }
  } catch (error) {
    // Fall through to the unscoped key.
  }
  return base;
}

export function loadSavedForm(documentType) {
  try {
    const raw = localStorage.getItem(userScopedKey(documentType));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
  } catch (error) {
    return null;
  }
}

export function saveForm(documentType, data) {
  try {
    localStorage.setItem(userScopedKey(documentType), JSON.stringify(data));
  } catch (error) {
    console.error('Could not save builder form data:', error);
  }
}

export function clearSavedForm(documentType) {
  try {
    localStorage.removeItem(userScopedKey(documentType));
  } catch (error) {
    console.error('Could not clear builder form data:', error);
  }
}

// Saved data is merged onto the current defaults so a form that gains a field
// later does not read back `undefined` into a controlled input.
export function mergeSavedForm(defaults, saved, arrayFields = []) {
  if (!saved) return defaults;
  const merged = { ...defaults, ...saved };
  arrayFields.forEach((field) => {
    const value = saved[field];
    merged[field] = Array.isArray(value) && value.length ? value : defaults[field];
  });
  Object.keys(merged).forEach((key) => {
    if (merged[key] === undefined || merged[key] === null) merged[key] = defaults[key];
  });
  return merged;
}
